import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { faClose } from '@fortawesome/pro-light-svg-icons/faClose'
import { Icon, Modal } from 'src/components'
import ModalBody from 'src/components/Modal/body'
import {
  DropZoneUploader,
  DropZoneUploaderProps,
  UploadResult
} from 'src/components/dropZoneUploader'
import { Actions, ComponentNames, Entities, EventNames, ScreenNames } from 'src/utils/datahub/enums'
import useSendDataHubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import { CommentType } from 'src/components/postComments'
import i18n from 'src/i18n'
import { AppDownloadButtons } from '../appDownloadButtons'
import { MediaModalProps, PathParams } from './mediaModal.types'
import { getDropZoneprops, getTitles } from './utils'

const MediaModal = ({ show, mediaType, onClose }: MediaModalProps) => {
  const [loading, setLoading] = useState(false)
  const { idCommunity, idPost } = useParams() as PathParams
  const { sendDataHubConsume } = useSendDataHubConsume()
  const titles = getTitles(i18n)
  const dropzoneProps = getDropZoneprops(i18n)

  const title = mediaType ? titles[mediaType]?.title : undefined
  const dropZoneProps: DropZoneUploaderProps = mediaType ? dropzoneProps[mediaType] : {}

  const handleClose = () => {
    if (!loading) {
      onClose()
    }
  }

  const handleDropZoneSuccess = (files?: UploadResult[]) => {
    onClose(files)
  }

  const handleDropZoneError = (error: unknown) => {
    const invalidFileSizeError = error === dropZoneProps?.errorMessages?.invalidFileSize

    if (mediaType === CommentType.DOCUMENT && invalidFileSizeError) {
      sendDataHubConsume({
        action: Actions.VIEW,
        entity: Entities.COMMUNITY,
        event: {
          screenName: ScreenNames.COMMUNITY_POST_COMMENT,
          eventName: EventNames.TRY_TO_UPLOAD_PDF_ATTACHMENT_ABOVE_THE_SIZE_LIMIT,
          componentName: ComponentNames.INPUT_COMMENT,
          communityId: Number(idCommunity),
          postId: idPost
        }
      })
    }
  }

  return (
    <Modal show={show} onClose={handleClose}>
      <ModalBody>
        <header className="_d-flex _align-items-center _justify-content-between _mb-4">
          {title && <h2 className="_text-4 _text-gray-700 _mb-0">{title}</h2>}

          <button
            className="_d-flex _cursor-pointer _border-0 _bg-transparent _ml-auto"
            disabled={loading}
            data-test="close-modal-button"
            onClick={handleClose}
          >
            <Icon icon={faClose} className="_text-4 _text-gray-700" />
          </button>
        </header>

        <div>
          {mediaType === CommentType.AUDIO ? (
            <AppDownloadButtons onClick={onClose} />
          ) : (
            <DropZoneUploader
              {...dropZoneProps}
              onLoading={setLoading}
              onSuccess={handleDropZoneSuccess}
              onError={handleDropZoneError}
            />
          )}
        </div>
      </ModalBody>
    </Modal>
  )
}

export default MediaModal
